import { ManufacturerType } from 'models/ManufacturerType';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const ManufacturerTypeActionType = {
    FETCH_MANUFACTURERTYPES: 'FETCH_MANUFACTURERTYPES',
    FETCH_MANUFACTURERTYPES_SUCCESS: 'FETCH_MANUFACTURERTYPES_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchManufacturerTypesAction {
    type: typeof ManufacturerTypeActionType.FETCH_MANUFACTURERTYPES
    payload: ApiPayload,
    returnPayload: ManufacturerType[],
    meta: {
        isApiCall: boolean
    },
}

export type IManufacturerTypeActions = IFetchManufacturerTypesAction

const baseUrl = 'api/manufacturers/types';
export class ManufacturerTypeActions {
    public static fetchManufacturerTypes(token: string): IManufacturerTypeActions {
        return {
            type: ManufacturerTypeActionType.FETCH_MANUFACTURERTYPES,
            payload: Api.fetchApiCall(baseUrl, token, ManufacturerTypeActionType.FETCH_MANUFACTURERTYPES_SUCCESS, ManufacturerTypeActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }
}